'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('`', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/remark-parse/lib/locate/code-inline.js
// module id = 370
// module chunks = 0 1 9 10